export const MenuList = [
  {
    title: 'Trades Manager',
    iconStyle: <i className="material-icons">trending_up</i>,
    to: 'trades',
  },
  {
    title: 'Puzzle',
    iconStyle: <i className="material-icons">extension</i>,
    to: 'puzzle',
  },
  {
    title: 'Backtest',
    iconStyle: <i className="material-icons">analytics</i>,
    to: 'backtest',
  },
  {
    title: 'Portafolio',
    iconStyle: <i className="material-icons">pie_chart</i>,
    to: 'portfolio',
  },
  {
    title: 'Copilotos',
    iconStyle: <i className="material-icons">psychology</i>,
    to: 'copilots',
  },
  {
    title: 'Orquestador',
    iconStyle: <i className="material-icons">tune</i>,
    to: 'orquestador',
  },
  {
    title: 'Estadísticas',
    iconStyle: <i className="material-icons">bar_chart</i>,
    to: 'statistics',
  },
  {
    title: 'Plan de Negocio',
    iconStyle: <i className="material-icons">business_center</i>,
    to: 'business-plan',
  },
  {
    title: 'Conexiones',
    iconStyle: <i className="material-icons">link</i>,
    to: 'connections',
  },
  {
    title: 'Configuraciones',
    iconStyle: <i className="material-icons">settings</i>,
    to: 'settings',
  },
];

export const LogoutMenu = {
  title: 'Cerrar Sesión',
  iconStyle: <i className="material-icons">logout</i>,
  to: '#logout',
};
